import {css} from "@panda/css";

import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";
import {ConsentFileLink} from "./ConsentFileLink";

interface IProps {
    template: IConsentTemplate;
}

export const ConsentCheckboxLabel = ({template}: IProps) => (
    <span className={labelRoot}>
        <span className={content}>{getConsentContent(template)}</span>
        <ConsentFileLink template={template} />
    </span>
);

const labelRoot = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%"
});

const content = css({
    display: "block"
});
import {css} from "@panda/css";

import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";
import {ConsentFileLink} from "./ConsentFileLink";

interface IProps {
    template: IConsentTemplate;
}

export const ConsentCheckboxLabel = ({template}: IProps) => (
    <span className={labelRoot}>
        <span className={content}>{getConsentContent(template)}</span>
        <ConsentFileLink template={template} />
    </span>
);

const labelRoot = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%"
});

const content = css({
    display: "block"
});
